"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledIcon = exports.StyledProtoButton = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Icon = _interopRequireDefault(require("../../IconicDisplayElements/Icon"));

var _ProtoButton = _interopRequireDefault(require("../ProtoButton"));

var _button = require("../../../styles/2_commonComponentStyles/button");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StyledProtoButton = (0, _styledComponents.default)(_ProtoButton.default).withConfig({
  displayName: "Buttonstyles__StyledProtoButton",
  componentId: "p1v8fd-0"
})(["", " ", ""], _button.baseButton, _button.buttonThemes);
exports.StyledProtoButton = StyledProtoButton;
var StyledIcon = (0, _styledComponents.default)(_Icon.default).withConfig({
  displayName: "Buttonstyles__StyledIcon",
  componentId: "p1v8fd-1"
})(["margin-right:", ""], function (props) {
  return props.theme.standardPadding;
});
exports.StyledIcon = StyledIcon;